<template>
  <div>
    <h2 class="content-heading">
      <i class="si si-basket mr-5"></i> Bestellingen
    </h2>

    <api-table-block ref="ordersTable" :fields="fields" :items="findAllOrders" default-sort-by="placed_at" item-label-singular="bestelling" item-label-plural="bestellingen">
      <template slot="before-block-content">
        <div class="block-content">
          <span class="d-none d-sm-inline" style="font-size: medium; font-weight: bold;"> Orderpicken: </span>

          <button type="button" class="btn btn-rounded btn-alt-secondary mr-5" @click="pickSelected">
            <i class="fa fa-check-square-o text-primary mx-5"></i>
            <span class="d-none d-sm-inline"> Pick</span>
          </button>

          <button type="button" class="btn btn-rounded btn-alt-secondary" @click="pick('single')" v-b-tooltip.hover.top="'Pick 20 oudste bestellingen die maar één product bevatten'">
            <i class="fa fa-step-backward text-danger mx-5"></i>
            <span class="d-none d-sm-inline">Single</span>
          </button>

          <button type="button" class="btn btn-rounded btn-alt-secondary" @click="pick('multi')" v-b-tooltip.hover.top="'Pick 10 oudste bestellingen die minimaal twee producten bevatten'">
            <i class="fa fa-step-backward text-danger mx-5"></i>
            <span class="d-none d-sm-inline">Multi</span>
          </button>

          <button type="button" class="btn btn-rounded btn-alt-secondary" @click="pick('all')" v-b-tooltip.hover.top="'Pick 10 oudste bestellingen'">
            <i class="fa fa-step-backward text-danger mx-5"></i>
            <span class="d-none d-sm-inline">Alles</span>
          </button>

          <div class="pull-right">
            <label class="css-control css-control-sm css-control-primary css-switch">
              <input type="checkbox" class="css-control-input" v-model="showOnlyNLOrders" @change="refresh">
              <span class="css-control-indicator"></span> NL
            </label>

            <label class="css-control css-control-sm css-control-primary css-switch ">
              <input type="checkbox" class="css-control-input" v-model="showOnlyBolOrders" @change="refresh">
              <span class="css-control-indicator"></span> Bol
            </label>

            <label class="css-control css-control-sm css-control-primary css-switch ">
              <input type="checkbox" class="css-control-input" v-model="showOnlyProcessing" @change="refresh">
              <span class="css-control-indicator"></span> Openstaand
            </label>

            <label class="css-control css-control-sm css-control-primary css-switch">
              <input type="checkbox" class="css-control-input" v-model="showOnlyDropship" @change="refresh">
              <span class="css-control-indicator"></span> Dropshipments
            </label>
          </div>
        </div>
      </template>

      <template slot="check" slot-scope="data">
        <label class="css-control css-control-primary css-checkbox" :key="data.item.number">
          <input type="checkbox" class="css-control-input" :checked="selectedOrders.includes(data.item.number)" @change="selectOrder(data.item.number, $event)">
          <span class="css-control-indicator"></span>
        </label>
      </template>
      <template slot="number" slot-scope="data">
        <a href="#" @click.prevent="openDetailModal(data.item.id)">#{{data.value}}</a>
      </template>
      <template slot="billing_person" slot-scope="data">
        {{data.value}} <small v-if="data.item.billing_company" class="text-muted">{{data.item.billing_company}}</small>
      </template>
      <template slot="placed_at" slot-scope="data">
        {{data.value | moment('calendar') | capitalize}}
      </template>
      <template slot="status" slot-scope="data">
        <order-status-badge :order="data.item" />
      </template>
      <template slot="actions" slot-scope="data">
        <div class="btn-group" role="group">
          <router-link class="btn btn-sm btn-secondary" :to="{ name: 'pick-orders', query: { orders: [data.item.number] }}">Pick</router-link>
          <button class="btn btn-sm btn-secondary  ml-3" @click="openDetailModal(data.item.id)">Details</button>
          <button class="btn btn-sm btn-secondary  ml-3" @click="openManualRefundModal(data.item)">Retourneren</button>
        </div>
      </template>
    </api-table-block>

    <barcode-scanner @scan="handleMessage" />
    <refund-detail-modal v-if="refundDetailModalShow && refund.id !== null" :key="refundDetailModalOrderId" :order-id="refundDetailModalOrderId" :refundId="refund.id" :includeRefundShipmentCosts="false" @close="refundDetailModalShow = false" ></refund-detail-modal>
    <order-detail-modal v-if="detailModalOrderId" :key="detailModalOrderId" :order-id="detailModalOrderId" @close="detailModalOrderId = null"></order-detail-modal>
    <select-barcode-scanner-widget></select-barcode-scanner-widget>
  </div>
</template>

<script>
import http from '../utils/http'
import ApiTableBlock from '../common/ApiTableBlock'
import OrderDetailModal from './OrderDetailModal'
import OrderStatusBadge from './OrderStatusBadge'
import BarcodeScanner from '../common/BarcodeScanner'
import RefundDetailModal from '../refunds/RefundDetailModal.vue'
import SelectBarcodeScannerWidget from '../barcode-scanner/SelectBarcodeScannerWidget.vue'
import Socket from '../barcode-scanner/socket'

export default {
  components: {
    ApiTableBlock,
    OrderDetailModal,
    OrderStatusBadge,
    BarcodeScanner,
    RefundDetailModal,
    SelectBarcodeScannerWidget
  },
  data () {
    return {
      fields: {
        check: {
          label: '',
          class: 'text-center',
          thStyle: 'width: 70px;'
        },
        number: {
          label: 'Bestelling',
          sortable: true,
          thStyle: 'width: 140px;'
        },
        billing_person: {
          label: 'Klant',
          sortable: true,
          thStyle: 'width: 30%;'
        },
        placed_at: {
          label: 'Datum',
          sortable: true
        },
        status: {
          label: 'Status',
          sortable: true
        },
        actions: {
          label: 'Acties',
          thStyle: 'width: 150px;'
        }
      },
      selectedOrders: [],
      refundDetailModalShow: false,
      detailModalOrderId: null,
      refundDetailModalOrderId: null,
      refund: null,
      showOnlyProcessing: true,
      showOnlyDropship: false,
      showOnlyBolOrders: false,
      showOnlyNLOrders: false
    }
  },
  computed: {
    ordersTable () {
      return this.$refs.ordersTable
    }
  },
  methods: {
    findAllOrders (params) {
      params['include'] = 'refund'

      if (this.showOnlyProcessing) {
        params['filter[status]'] = 'processing,picked'
      }

      if (this.showOnlyDropship) {
        params['filter[lines.product.dropship]'] = 'society_of_lifestyle,present_time,de_eekhoorn'
      }

      if (this.showOnlyBolOrders) {
        params['filter[specific_orders]'] = 'BOL-'
      }

      if (this.showOnlyNLOrders) {
        params['filter[specific_orders]'] = 'NL-'
      }

      return this.$api.getOrders(params)
    },
    refresh () {
      this.ordersTable.refresh()
    },
    selectOrder (number, e) {
      if (e.target.checked) {
        this.selectedOrders.push(number)
      } else {
        const index = this.selectedOrders.indexOf(number)
        if (index > -1) {
          this.selectedOrders.splice(index, 1)
        }
      }
    },
    pickSelected () {
      if (this.selectedOrders.length === 0) {
        this.$swal('Niks geselecteerd 🙄', 'Selecteer welke bestellingen je wilt picken.', 'warning')
        return
      } else if (this.selectedOrders.length > 10) {
        this.$swal('Te veel geselecteerd 🤔', 'Je kunt maximaal 10 bestellingen per keer picken.', 'warning')
        return
      }

      this.$router.push({ name: 'pick-orders', query: { orders: this.selectedOrders, singleBin: false } })
    },
    async pick (pickType) {
      const params = {
        'filter[status]': 'processing',
        'per_page': 10,
        'sort': 'placed_at'
      }

      let singleBin = false

      if (pickType === 'single') {
        params['filter[linesCount]'] = pickType
        params['per_page'] = 20
        singleBin = true
      }

      if (pickType === 'multi') {
        params['filter[linesCount]'] = pickType
      }

      const orderNumbers = await this.$api.getOrderNumbers(params)

      if (orderNumbers.length === 0) {
        this.$swal('Geen openstaande bestellingen 😎', 'Dat scheelt weer.', 'warning')
        return
      }

      this.$router.push({ name: 'pick-orders', query: { orders: orderNumbers, singleBin: singleBin } })
    },
    createRefund (orderId) {
      const data = {
        order_number: orderId
      }

      this.$http.post(`/refunds`, data)
        .then((response) => {
          this.saving = false
          this.alert = { variant: 'success', message: 'Opgeslagen' }
          this.refund = response.data.data
        })
        .catch(() => {
          this.saving = false
          this.$swal('Oeps! 😳', `Er is iets fout gegaan bij het aanmaken van de retour. Probeer het opnieuw.`, 'error')
        })
    },
    openDetailModal (orderId) {
      this.detailModalOrderId = orderId
    },
    openManualRefundModal (order) {
      this.createRefund(order.number)

      this.refundDetailModalShow = true
      this.refundDetailModalOrderId = order.id
    },
    handleMessage (event) {
      http.get(`/order-barcode-scanned/${event}`)
        .then((result) => {
          this.detailModalOrderId = result.data.data.id
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze product konden we niet vinden in één van de gepickte bestellingen. Controleer de bestellingen goed.', 'warning')
        })
    }
  },
  created () {
    Socket.$on('message', this.handleMessage)
  },
  beforeDestroy () {
    Socket.$off('message', this.handleMessage)
  }
}
</script>



// WEBPACK FOOTER //
// OrdersPage.vue?882fe3ee